import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_JOB_SUBSCRIPTION_BY_ID_PATH,
  GET_JOB_SUBSCRIPTIONS_PATH,
  GetJobSubscriptionByIdErrorDto,
  GetJobSubscriptionByIdRequestPathVariables,
  GetJobSubscriptionsErrorDto,
  GetJobSubscriptionsRequestQueryParams,
  GetJobSubscriptionsSuccessDto,
  JobSubscription,
} from '@/api/rest/resources/types/jobSubscriptions';

type SuccessDto = GetJobSubscriptionsSuccessDto;
type ErrorDto = GetJobSubscriptionsErrorDto;
type QueryParams = GetJobSubscriptionsRequestQueryParams;

export const JOB_SUBSCRIPTIONS_QUERY_KEY = 'job-subscriptions';

export const useJobSubscriptions = (queryParams?: QueryParams) => {
  const queryFn = async () => {
    return getRequest<SuccessDto, undefined, QueryParams>(GET_JOB_SUBSCRIPTIONS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: [JOB_SUBSCRIPTIONS_QUERY_KEY, queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};

export const useJobSubscription = (id: string) => {
  const queryFn = async () => {
    return getRequest<JobSubscription, GetJobSubscriptionByIdRequestPathVariables>(GET_JOB_SUBSCRIPTION_BY_ID_PATH, {
      id,
    });
  };

  return useSuspenseQuery<JobSubscription, GetJobSubscriptionByIdErrorDto>({
    queryKey: [JOB_SUBSCRIPTIONS_QUERY_KEY, id],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
